import React, { PureComponent } from 'react'
import {
  string, func, shape, bool,
} from 'prop-types'
import Button from '@active/react-ui/Button'
import Form from '@active/react-ui/Form'
import FormField from '@active/react-ui/FormField'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormStaticField from '@active/react-ui/FormStaticField'
import { withI18n } from '@active/react-utils/i18n'
import DobSelectorWithValueParse from '../../../DobSelectorWithValueParse'
import ConfirmedPassword from '../../../ConfirmedPassword'
import CountryDropdown from '../../../CountryDropdown'
import ActiveConsents from '../../../AgreementGroups'
import DefaultComponentLayout, { LayoutContent, ErrorContent } from '../../../Layout'
import CoppaEmailInput from '../../../CoppaEmailInput'
import { getUrlParams } from '../../../../../shared/utils/commonUtils'
import I18nMessage from '../../../I18nMessage'
import './FacebookCreateAccount.scss'

class FacebookCreateAccount extends PureComponent {
  static propTypes = {
    i18n: func.isRequired,
    response: shape({ email: string.isRequired }).isRequired,
    facebookCreateAccount: func.isRequired,
    configureTrack: func.isRequired,
    signupSuccessCallback: func,
    defaultHandleComplete: func.isRequired,
    countryCodes: string,
    Header: func,
    clientConfig: shape({
      suppressActiveWaiver: bool,
      useCustomizeWaiver: bool,
      waiverAttachementObjectIds: string,
    }).isRequired,
  }

  static defaultProps = {
    countryCodes: undefined,
    signupSuccessCallback: undefined,
    Header: null,
  }

  constructor(props) {
    super(props)
    this.state = {
      resetAgrees: false,
      showCoppaEmailInput: false,
    }
  }

  componentDidMount() {
    const { configureTrack } = this.props
    configureTrack({
      eventName: 'CreateAccount',
      widget: 'create_account',
      pageType: 'create account',
    })
  }

  handleSubmit = ({ dob, pwd }) => {
    const errorMsg = this.Sub && this.Sub.agreementValidator()
    if (errorMsg) return
    const {
      response: { email },
      facebookCreateAccount,
      response,
      signupSuccessCallback,
      defaultHandleComplete,
      countryCodes,
      i18n,
      clientConfig: {
        suppressActiveWaiver,
        useCustomizeWaiver,
        waiverAttachementObjectIds,
      },
    } = this.props
    const formatDob = {
      dobMonth: new Date(dob).getMonth() + 1,
      dobDay: new Date(dob).getDate(),
      dobYear: new Date(dob).getFullYear(),
    }

    const { selectedCountryCode } = this.state

    const data = {
      email,
      pwd,
      selectedCountryCode,
      countryCode: selectedCountryCode,
      countriesInfo: countryCodes,
      regagree: true,
      suppressActiveWaiver,
      useCustomizeWaiver,
      waiverAttachementObjectIds,
      ...response,
      ...formatDob,
    }
    // Suppress account creation email if 'sace' is true
    const { sace } = getUrlParams()
    if (sace === 'true') { data.suppressAccountCreationEmail = true }

    facebookCreateAccount({
      params: data,
      resolve: ({
        status,
        loginURL,
        ssoToken,
        message,
        pendingKey,
        reason,
        ...rest
      }) => {
        if (status === 'SUCCESS') {
          if (signupSuccessCallback) {
            signupSuccessCallback({
              email: response.email,
              // Suppress account creation email if 'sace' is true
              sace: sace === 'true',
              status,
              loginURL,
              ssoToken,
              message,
              pendingKey,
              reason,
              ...rest,
            })
          } else {
            defaultHandleComplete({ loginURL, ssoToken })
          }
        } else if (status === 'FAILURE' && message) {
          if (message === 'COPPA') {
            this.setState({
              showCoppaEmailInput: true,
              pendingKey: pendingKey,
            })
          } else {
            let messge = i18n('passport.error.server.default')
            if (message === 'INELIGIBLE_FOR_REGISTRATION') {
              if (reason === 'AGE_REQUIREMENT') {
                messge = i18n('passport.error.server.ineligible.age')
              } else {
                messge = i18n('passport.error.server.ineligible')
              }
            }
            this.setState({
              errorMsg: messge,
              showError: true,
            })
          }
        } else {
          this.setState({ errorMsg: message, showError: true })
        }
      },
      reject: ({ message }) => {
        this.setState({
          showError: true,
          errorMsg: message || '',
        })
      },
    })
  }

  handleChangeCountry = value => {
    this.setState({
      selectedCountryCode: value,
      resetAgrees: true,
    })
  }

  handleCheckboxChange = () => {
    this.setState({ resetAgrees: false })
  }

  handleChange = () => {
    this.setState({
      showError: false,
      errorMsg: null,
    })
  }

  formLevelValidate = () => {
    const errorMsg = this.Sub && this.Sub.agreementValidator()
    return new Promise(resolve => {
      setTimeout(() => {
        errorMsg
          ? resolve(errorMsg)
          : resolve()
      }, 1000)
    })
  }

  render() {
    const {
      response, response: { email }, Header, i18n, ...rest
    } = this.props
    const initialValues = response
    const {
      selectedCountryCode,
      resetAgrees,
      showError,
      errorMsg,
      showCoppaEmailInput,
      pendingKey,
    } = this.state

    if (showCoppaEmailInput) {
      return (
        <CoppaEmailInput Header={Header} pendingKey={pendingKey} {...rest} />
      )
    }

    return (
      <DefaultComponentLayout nameSpace="passport-ui-app__facebook_create-acccount" Header={Header}>
        <LayoutContent title message="passport.facebook.createAccount.title" />
        <LayoutContent subTitle message="passport.facebook.createAccount.subTitle" />
        <LayoutContent main>
          {showError && <ErrorContent errorMsg={errorMsg} />}
          <Form
            onSubmit={this.handleSubmit}
            onChange={this.handleChange}
            initialValues={initialValues}
            validate={this.formLevelValidate}
          >
            <FormGroup name="email" withoutLayout>
              <FormLabel><I18nMessage id="passport.common.label.emailAddress" /></FormLabel>
              <FormStaticField />
            </FormGroup>

            <FormGroup name="dob" required withoutLayout>
              <FormLabel><I18nMessage id="passport.common.label.dob" /></FormLabel>
              <FormField
                className="passport__dob"
                as={DobSelectorWithValueParse}
              />
            </FormGroup>

            <FormGroup name="countryCode" required withoutLayout>
              <FormLabel id="CountryDropdownLabel" htmlFor="countryCode"><I18nMessage id="addressForm.addressField.country" /></FormLabel>
              <FormField
                aria-required
                aria-labelledby="CountryDropdownLabel"
                onChange={this.handleChangeCountry}
                className="passport__dob"
                as={CountryDropdown}
              />
            </FormGroup>

            <FormGroup withoutLayout>
              <ConfirmedPassword
                name="pwd"
                required
                username={email}
              />
            </FormGroup>

            <ActiveConsents
              name="agreed"
              onRef={node => { this.Sub = node }}
              handleCheckboxChange={this.handleCheckboxChange}
              selectedCountryCode={selectedCountryCode}
              resetAgrees={resetAgrees}
              {...this.props}
            />

            <Button type="super" submit className="facebook_create-acccount">
              <I18nMessage id="passport.common.btn.signUp" />
            </Button>
          </Form>
        </LayoutContent>
      </DefaultComponentLayout>
    )
  }
}

export default withI18n(FacebookCreateAccount)
